/**
 * PDF eines Rezepts herunterladen: Format und Umfang wählen. Die gewählte
 * Menge und die Einheiten kommen aus der Adresszeile (wie beim Kochmodus).
 */
import { useState } from 'react';
import { texts } from '../texts/de.ts';

interface PdfMenuProps {
  readonly recipeId: string;
  /** Suchteil der Adresse mit Menge, Form und Einheiten („?menge=4“). */
  readonly search: string;
}

/** Auswahl und Download-Verweis. */
export function PdfMenu({ recipeId, search }: PdfMenuProps) {
  const [format, setFormat] = useState<'a4' | 'a5'>('a4');
  const [photos, setPhotos] = useState(true);
  const [animations, setAnimations] = useState(true);
  const [nutrition, setNutrition] = useState(true);

  const params = new URLSearchParams(search);
  params.set('format', format);
  if (!photos) params.set('bilder', '0');
  if (!animations) params.set('animationen', '0');
  if (!nutrition) params.set('naehrwerte', '0');
  const href = `/api/recipes/${recipeId}/pdf?${params.toString()}`;

  return (
    <details className="relative">
      <summary className="inline-flex cursor-pointer list-none items-center gap-2 rounded-xl border border-border-subtle px-4 py-2.5 text-sm">
        {texts.pdf.button}
      </summary>
      <div className="absolute z-20 mt-2 w-64 space-y-3 rounded-2xl border border-border-subtle bg-surface-raised p-4 text-sm shadow-lg">
        <div className="flex gap-2" role="radiogroup" aria-label={texts.pdf.format}>
          {(['a4', 'a5'] as const).map((value) => (
            <label key={value} className="flex items-center gap-1.5">
              <input
                type="radio"
                name={`pdf-format-${recipeId}`}
                checked={format === value}
                onChange={() => setFormat(value)}
                className="accent-accent"
              />
              {value.toUpperCase()}
            </label>
          ))}
        </div>
        {(
          [
            [texts.pdf.photos, photos, setPhotos],
            [texts.pdf.animations, animations, setAnimations],
            [texts.pdf.nutrition, nutrition, setNutrition],
          ] as const
        ).map(([label, value, set]) => (
          <label key={label} className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={value}
              onChange={(event) => set(event.target.checked)}
              className="accent-accent"
            />
            {label}
          </label>
        ))}
        <a
          href={href}
          download
          className="block rounded-xl bg-accent px-4 py-2 text-center font-semibold text-on-accent"
        >
          {texts.pdf.download}
        </a>
        <p className="text-xs text-content-muted">{texts.pdf.hint}</p>
      </div>
    </details>
  );
}
